var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar'),_c('v-main',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-img',{staticStyle:{"position":"absolute","width":"100vw"},attrs:{"src":require("@/assets/header_bg.svg"),"transition":"scroll-y-transition"}})],1),_c('router-view')],1),_c('Footer'),_c('Loading'),_c('ErrorDialog'),_c('ProfileFormPopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }